/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$( document ).ready(function() {

  var desktopMode = false;
  if (window.innerWidth >= 1024) {
    desktopMode = true;
    $('.ProductItem__Carousel .Carousel__Cell:first-child').removeClass('is-visible');
  }
 var carouselSlider = $('.ProductItem__Carousel').flickity({draggable: true,fade: false,pageDots: false, wrapAround: true,   cellSelector: '.Carousel__Cell.is-visible' });

 // if (window.innerWidth >= 1024) {
 //   carouselSlider.flickity( 'select', 1, true, true );
 // }

 $(window).on("load resize",function(e){
     //
     if (window.innerWidth >= 1024 && !desktopMode) {
       desktopMode = true;
       $('.ProductItem__Carousel .Carousel__Cell:first-child').removeClass('is-visible');
       carouselSlider = $('.ProductItem__Carousel').flickity('destroy');
         carouselSlider.flickity({draggable: true,fade: false,pageDots: false, wrapAround: true,   cellSelector: '.Carousel__Cell.is-visible' });
         // carouselSlider.flickity( 'select', 1, true, true );

       // carouselSlider.flickity('resize');
     } else if (window.innerWidth < 1024 && desktopMode) {
       desktopMode = false;
       $('.ProductItem__Carousel .Carousel__Cell:first-child').addClass('is-visible');
       carouselSlider = $('.ProductItem__Carousel').flickity('destroy');
         carouselSlider.flickity({draggable: true,fade: false,pageDots: false, wrapAround: true,   cellSelector: '.Carousel__Cell.is-visible' });

     }


   if($('body').hasClass('template-cart')){
          var bar_height =$('#shopify-section-announcement').height();
  		  var header_height=$('#shopify-section-header').height();
      	   var rightwidth = $('.Cart__total-container').width();
                       $(window).scroll(function() {
         var currentScroll = $(window).scrollTop();
       		 if (currentScroll >= bar_height + header_height) {
                  if($(window).width() > 990){
                      $('.Cart__Recap').css({
                      position: 'fixed',
                      top:bar_height+header_height,
                      width:rightwidth
                  });
                }

    		} else {
              $('.Cart__Recap').css({
                  position: 'static',
                  width:rightwidth
              });
    		}
    var div1 = $(".Cart__Recap");
    var div2 = $(".stop-sticky");
    var div1_top = div1.offset().top;
    var div2_top = div2.offset().top;
    var div1_bottom = div1_top + div1.height();
    var div2_bottom = div2_top + div2.height()+4000;

    if (div1_bottom >= div2_top && div1_top < div2_bottom) {
        if($(window).width() > 990){
        div1.css({"top" : -(currentScroll + div1.innerHeight() - div2_top +30),width:rightwidth});
        }
      }


});

      }else{
        $('.Cart__Recap').removeAttr( 'style' );
      }


    if($(window).width() <= 640){
        var $press_carousel_main 	= $('.carousel-nav').flickity({ contain: true,draggable: false,pageDots: true,fade: false});
        var $press_carousel_nav 	    = $('.carousel-main').flickity({asNavFor: '.carousel-nav', draggable: false,pageDots: false});

        var tabclass = $(".tab-header").find(".active_tab").attr("class");
        if(tabclass != undefined){
          if(tabclass.indexOf('login-tab') > -1){
             $(".tab-header li").removeClass("active_tab");
             $('.customer_register').hide();
             $('.customer_login').show();
             $(".login-tab").addClass("active_tab");
          }else if(tabclass.indexOf('register-tab') > -1){
             $(".tab-header li").removeClass("active_tab");
             $('.customer_register').show();
             $('.customer_login').hide();
             $(".register-tab").addClass("active_tab");
          }
        }else{
             $(".tab-header li").removeClass("active_tab");
             $('.customer_register').hide();
             $('.customer_login').show();
             $(".login-tab").addClass("active_tab");
        }
     }
    else{
       $('.customer_register').show();
       $('.customer_login').show();
       $(".tab-header li").removeClass("active_tab");

      $('.content_div div:first-child').css('display','block');
      $('.image_div div:first-child').addClass('is-selected');

       $(".image_div .carousel-cell ").click(function(){
         $(".image_div .carousel-cell ").removeClass('is-selected');
         $(this).addClass('is-selected');
          var index = $(this).attr('data-index');
           $(".content_div .carousel-cell").each(function() {
             if($(this).attr('data-index') == index)
             {
               $('.content_div .carousel-cell').css('display','none');
               $(this).css('display','block');
             }
           });
        });


     }

     /* Account page tab click */
     $(document).on("click",".login-tab",function(){
        $(".tab-header li").removeClass("active_tab");
        $(".customer_register").hide();
       	$(".customer_login").show();
        $(this).addClass("active_tab");
     });
     $(document).on("click",".register-tab",function(){
        $(".tab-header li").removeClass("active_tab");
        $(".customer_login").hide();
       	$(".customer_register").show();
        $(this).addClass("active_tab");
     });

      $(".Timeline__Item").each(function() {

              if($(this).hasClass('is-selected')){
                  var height = $(this).find('.Timeline__Header').outerHeight()+$(this).find('.Timeline__ImageWrapper').height();

                  if($(window).width() <= 640){
                         $(this).parent().css("height",height);
                  }
                  else {
                  		$(this).parent().removeAttr("style");
                 }
               }
            });

      $(".Timeline__NavWrapper .Timeline__NavItem").click(function(){
              var data_index=$(this).attr('data-index');
                 $(".Timeline__Item" ).each(function() {
                   var data = $(this).attr('data-index')
                      if(data_index == data){
                         var height = $(this).find('.Timeline__Header').outerHeight() + $(this).find('.Timeline__ImageWrapper').height();

                        if($(window).width() <= 640){
                           $(this).parent().css("height",height);
                        }
                        else {
                              $(this).parent().removeAttr("style");
                       }
                    }
                 });
             });



  });

    /* Announcer  Scroll */
  if ($('.AnnouncementBar__Dynamic').length > 1) {
    setInterval(function(){
      var nextActive = $('.AnnouncementBar__Dynamic--Active').next();

      $('.AnnouncementBar__Dynamic--Active').removeClass('AnnouncementBar__Dynamic--Active');

      setTimeout(function(){
           if(nextActive.length > 0) {
        nextActive.addClass('AnnouncementBar__Dynamic--Active');
      } else {
        $('.AnnouncementBar__Dynamic:first-child').addClass('AnnouncementBar__Dynamic--Active');
      }
      }, 250);



    }, $('.AnnouncementBar__Wrapper').data('timer') * 1000);

  }

    /* Currency Site switcher */
    function currencyFormSubmit(event) {
      event.target.form.submit();
    }

    document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
      element.addEventListener('change', currencyFormSubmit);
    });

    document.querySelectorAll('.CurrencySelector__Country-select').forEach(function(element) {
      element.addEventListener('change', function(ev){
        window.location.href = ev.currentTarget.value + window.location.pathname;
      });
    });


    $('.product-testimonials').flickity({draggable: false, fade: false, pageDots: false, wrapAround: true });
    $('.product-testimonials__item').addClass("is-loaded");
});


$(document).on("theme:loading:end", function(){
  $('.ProductItem__Carousel').flickity({draggable: true,fade: false,pageDots: false, wrapAround: true,   cellSelector: '.Carousel__Cell.is-visible' });
})

$(function() { // Wait for page to finish loading.
    if(navigator != undefined && navigator.userAgent != undefined) {
        user_agent = navigator.userAgent.toLowerCase();
        if(user_agent.indexOf('android') > -1) { // Is Android.
            $(document.body).addClass('android');
        }
    }
});

 /* filter accordin work -start*/
  $(document).on('click', '.filter-menu h4', function(e){

		if($(this).hasClass('find')){
             $(this).removeClass('open');
             $(this).removeClass('find');
          }else{

             $('.filter-menu').find('h4').removeClass('open');
             $('.filter-menu').find('h4').removeClass('find');
             $(this).addClass('open');
             $(this).addClass('find');
           }

          });

/* filter accordin work -end */

// Shop now link script append in search page
/*$(function(){

  setTimeout(function(){
     $('.snize-category').each(function(){
    	var thumbnail = $(this).find(".snize-thumbnail").html();
       if(thumbnail!=undefined){
         var url = $(this).find(".snize-view-link").attr("href");
         $(this).find('.snize-overhidden').after('<a href="'+url+'" class="snize-shop-now">Shop Now</a>');
       }
     });
  },1500);

});*/



function mobileload(){
  var mobile = getMobileOperatingSystem();
  if(mobile!="unknown"){
    console.log(mobile);
    if(mobile == "iOS" ||  mobile == "Android" || mobile == "Windows Phone" ){
      $(".option_avail").hide();
    }
  }else{
    if($(window).width() <= 1024){
      $(".option_avail").hide();
    }
  }
}
mobileload();
function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

/*  Back to top script */
$(function(){
  $(window).scroll(function(){
    var w = $(window).width();
     var pr = $('.Header__Wrapper').height();
    if(w >= 300 && w<=1030){
      if($(this).scrollTop()>=pr){
        $(".back-to-top").show();
      }else{
        $(".back-to-top").hide();
      }
    }
  });

  $('.back-to-top').click(function(){
		$('html, body').animate({scrollTop : 0},700);
		return false;
  });
});

/* Header class add resize script */
$(window).resize(function(){
  var w = $(this).width();
  if(w>1240){
    $(".Header--initialized").addClass("Header--center header--center");
  }
});

var overlay = document.querySelector('.PageOverlay');
var quickBuyWrapper = document.querySelector('.product-form-sticky-wrapper');
var allInputs = document.querySelectorAll('.radio_check');
var mainAdd = document.querySelector('.ProductForm__AddToCart');

function loopSwatch() {
  var addToCarts = document.querySelectorAll('.SizeSwatchAdd');
  for(const addToCart of addToCarts) {
    addToCart.addEventListener('click', function(e){
      document.querySelector('.option-warning').style.display = 'none';
      mainAdd.classList.remove('ProductForm__AddToCart--select-option');
      mainAdd.setAttribute('data-action', 'add-to-cart');
      if(document.querySelector('.ProductForm--sticky')) {
        e.preventDefault();
        stickyForm.classList.remove('active');
        overlay.classList.remove('is-visible');
        select.value = addToCart.dataset.id;
        document.querySelector('.ProductForm__AddToCart').click(); 

        for(const radio of allInputs) {
          radio.checked = false;
        }
      }
    })
  }
}

var preventSubmit = document.querySelector('.ProductForm__AddToCart--select-option');
preventSubmit.addEventListener('click', function(event){
  if(!document.querySelector('.ProductForm--sticky')) { 
    event.preventDefault();
    document.querySelector('.option-warning').style.display = 'inline';
  }
});

loopSwatch();

if(quickBuyWrapper && window.innerWidth < 1008) {
    var stickyForm = document.querySelector('.Product-sticky');
    var stickyButton = document.querySelector('.sticky-add-to-cart');
    var chat = document.getElementById('launcher');
    var closeBtn = document.querySelector('.close-sticky-form');
    var select = document.querySelector('select[name="id"]');
    stickyButton.addEventListener('click', function(e){
      e.preventDefault();
      stickyForm.classList.add('active');
      document.getElementById('launcher').style.display = 'none';
      overlay.classList.add('is-visible');
      mainAdd.setAttribute('data-action', 'add-to-cart');
    })
    closeBtn.addEventListener('click', function(e){
      e.preventDefault();
      stickyForm.classList.remove('active');
      document.getElementById('launcher').style.display = 'block';
      overlay.classList.remove('is-visible');
    });

    loopSwatch();

    window.addEventListener("scroll", function(event){
        var pos = (quickBuyWrapper.offsetTop + quickBuyWrapper.offsetHeight);
        var scroll = this.scrollY;

        if(scroll > pos) {
          quickBuyWrapper.querySelector('form').classList.add('ProductForm--sticky');
          mainAdd.classList.remove('ProductForm__AddToCart--select-option');
          mainAdd.setAttribute('data-action', 'add-to-cart');
          loopSwatch()
        } else {
          quickBuyWrapper.querySelector('form').classList.remove('ProductForm--sticky');
          mainAdd.classList.add('ProductForm__AddToCart--select-option');
          mainAdd.removeAttribute('data-action');
          loopSwatch()
        }
    });
}